import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { Form } from 'src/components/Antd';
import { Select } from 'src/components/Antd/Select';
import { useI18n } from 'src/hooks/useRouterChange';
import { generalFilterOptions } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import css from './tag.module.less';

const Item = Form.Item;
const AddTags = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const { options, onCancel, onOk } = props;
  return (
    <React.Fragment>
      <div className={css.container}>
        <Form
          form={form}
          onFinish={(v) => {
            const { tags } = v;
            if (onOk) onOk(tags);
          }}>
          <ItemWrapper
            title={getI18n('customerList.addTags.customerManualTag')}>
            <Item
              name='tags'
              rules={[
                {
                  required: true,
                  message: getI18n('customerList.addTags.msg'),
                },
              ]}>
              <Select
                size='large'
                mode='multiple'
                showArrow
                selectClassName={css.select}
                suffixIcon={<Icon type='iconsearch' />}
                filterOption={generalFilterOptions}
                placeholder={getI18n(
                  'customerList.advancedFilter.searchandselectcustomertag',
                )}>
                {(options || []).map((i) => {
                  const { value, label } = i;
                  return (
                    <Select.Option value={value} key={value}>
                      {label}
                    </Select.Option>
                  );
                })}
              </Select>
            </Item>
          </ItemWrapper>
        </Form>
      </div>{' '}
      <ModalFooter
        onOk={() => {
          form.submit();
        }}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};
export default AddTags;
